import Toast from "../../core-ui/Toast.tsx";
import AssetCover, { ImageSource } from "./AssetCover.tsx";
import { ComponentPropsWithoutRef } from "react";

type AssetCoverToastProps = {
  vbid: string;
  source?: ImageSource;
} & ComponentPropsWithoutRef<typeof Toast>;

/**
 * A special toast that shows a cover image with text
 */
export default function AssetCoverToast(props: AssetCoverToastProps) {
  const { vbid, noIcon = true, source, ...otherProps } = props;
  // noIcon defaults true when using an image but you can have it if you want

  return (
    <Toast
      startCol={
        <AssetCover
          style={{ maxWidth: 70 }}
          vbid={vbid}
          width={120}
          width2x={240}
          alt=""
          source={source}
        />
      }
      noIcon={noIcon}
      {...otherProps}
    />
  );
}
